export default {
  main: {
    site_id: 18758902,
    title: "Queenco",
    enableWorldCup: true,
    showPopularSection: false,
    staffPassword: "0",
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    homeBannerSlides: [
      {
        fileType: 'jpeg',
        path: "/betting/prematch",
      }
    ],
    websitePasswordHash: "571124337b0ebaeb67e6442d036554ff93f9850901fe648fb50591fd7eca0b08",
    alwaysShowCheckTicket: true,
    availableLanguages: {
      "@replace": true,
      eng: {
        short: "EN",
        name: "ENG",
        region: "UnitedKingdom",
        order: 1,
      },
      chi: {
        short: "CH",
        name: "CHN",
        region: "China",
        order: 9,
      },
    },
  },
  cashout: {
    enablePartial: true,
  },
  betslip: {
    enableSuperbetToggle: false,
    enableBookingId: false,
    staticStakes: ["5", "10", "20", "50", "100", "250"],
    enableCounterOffer: false,
    betDetailsOrder: ["total_odd", "min_possible_win", "total_stake", "possible_win"],
  },
  routes: [
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      url: 'betting/live/all',
      name: 'Live',
      type: 'live',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/live/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: 'betting/prematch/all',
      type: 'prematch',
      name: 'Sport',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: 'betting/results',
      name: 'Results',
      enabled: true,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
  ],
  adminPageButtons: [
    {
      name: "Admin User",
      type: "adminUserSections",
      hideOnRestrictMode: false,
      enabled: true,
    },
    {
      name: "Application and terminal management",
      type: "applicationAndTerminal",
      enabled: true,
    },
    {
      name: "Tickets",
      type: "lastTicket",
      enabled: true,
    },
    {
      name: "Financial tracking",
      type: "financialTracking",
      enabled: true,
      hideOnRestrictMode: false,
    },
    {
      name: "Open last log file",
      type: "openLastLogFile",
      enabled: true,
      hideOnRestrictMode: true,
    },
    {
      name: "Lock",
      type: "lockAndUnlock",
      param: {
        type: "lock",
      },
      enabled: true,
    },
    {
      name: "Unlock",
      type: "lockAndUnlock",
      param: {
        type: "unlock",
      },
      enabled: true,
    },
    {
      name: "Devices",
      type: "devices",
      enabled: true,
      hideOnRestrictMode: true,
    },
  ],
  staticStakeCounts: { default: [5, 10, 20, 50, 100] },
  //"defaultTerminalParams": { pid: 18758902, tid: 32375, token: "09r/EQ==", currency: 'KHR' },
  defaultTerminalParams: { pid: 18758902, tid: 32649, token: "2l8kEg==", currency: "USD" },
  sportsbook: {
    sportList: {
      enableLiveAll: false,
      enablePredefinedMultiples: false
    }
  }
};
